module.exports = __webpack_public_path__ + "img/1 (71).c603f23b.png";